'use strict';

import angular from 'angular';

import startFromFilter from './startFrom.filter.js';
import ListCtrl from './static/list.controller.js';
import GtListDirective from './dynamic/list.directive.js';

export default angular.module('georgeApp.list', [])
  .filter('startFrom', startFromFilter)
  .controller('ListCtrl', ListCtrl)
  .directive('gtList', GtListDirective)
  .name;
